<!--  -->
<template>
    <div class="main">
        <!-- 标题  -->
        <p class="title-Individual-center">
            <span>道具管理</span>
            <i class="el-icon-arrow-right"></i>
            <span class="span-Individual-center">{{ routeName }}</span>
        </p>
        <div class="box-vip">
            <div
                v-for="item in vipList"
                :key="item.id"
                class="vip-card-wrap"
                :class="'vip-card-wrap--' + vipCardTheme(item.id)"
            >
                <img class="vip-card-bg" :src="vipCardBgSrc(item.id)" alt="" />
                <!-- 设计稿左上角标题（与 174px 标题区对齐，不依赖底图是否带字） -->
                <div class="vip-card-header-text">
                    <div
                        v-if="Number(item.id) === 1"
                        class="vip-card-header-main"
                    >
                        普通VIP
                    </div>
                    <template v-else-if="Number(item.id) === 2">
                        <div class="vip-card-header-row">
                            <span class="vip-card-header-main">VIP</span>
                            <span class="vip-card-header-badge vip-card-header-badge--vip"
                                >VIP</span
                            >
                        </div>
                        <p class="vip-card-header-sub">开通VIP享受更多权益</p>
                    </template>
                    <template v-else>
                        <div class="vip-card-header-row">
                            <span class="vip-card-header-main">SVIP</span>
                            <span
                                class="vip-card-header-badge vip-card-header-badge--svip"
                                >SVIP</span
                            >
                        </div>
                        <p class="vip-card-header-sub">开通SVIP享受更多权益</p>
                    </template>
                </div>
                <div class="vip-card-content">
                   
                    <template
                        v-if="item.companyVipProductVos && item.companyVipProductVos.length > 0"
                    >
                        <div class="vip-benefits-title">
                            每月权益
                        </div>
                        
                        <ul class="vip-benefits-list">
                            <li
                                v-for="(prod, pi) in item.companyVipProductVos"
                                :key="pi"
                            >
                                {{ prod.prodName }}
                                {{ prod.interestsCount }}次（{{
                                    formatExpire(
                                        prod.expiredType,
                                        prod.expiredNum
                                    )
                                }}）
                            </li>
                        </ul>
                    </template>
                    <div v-else class="vip-plain-empty">
                        <p class="vip-plain-empty-title">暂无任何权益</p>
                        <p class="vip-plain-empty-desc">
                            如需要精英卡或人才信用卡请开通相关等级权益
                        </p>
                    </div>
                    <div
                        v-if="
                            item.companyVipInterestsPriceVos &&
                            item.companyVipInterestsPriceVos.length > 0
                        "
                        class="vip-price-grid"
                    >
                        <div
                            v-for="(p, pi) in item.companyVipInterestsPriceVos"
                            :key="pi"
                            class="vip-price-cell"
                        >
                            <span class="vip-price-month">{{ p.buyMonth }}个月</span>
                            <span class="vip-price-num">¥ {{ p.price }}</span>
                        </div>
                    </div>
                    <div class="vip-card-footer">
                        <button
                            v-if="
                                item.companyVipInterestsPriceVos &&
                                item.companyVipInterestsPriceVos.length > 0 &&
                                !(
                                    Number(companyVipLevel) === 2 &&
                                    Number(item.id) === 2
                                )
                            "
                            type="button"
                            class="vip-action-btn"
                            @click="openBuyDialog(item)"
                        >
                            {{ getVipActionText(item) }}
                        </button>
                    </div>
                </div>
            </div>
            <dialogModel
              title="付款"
              :visible.sync="buyDialogVisible"
              width="800px"
              :footer="false"
              @handleClose="buyDialogVisible = false"
            >
                <div class="vip-buy-dialog" v-if="buyVip">
                    <div v-if="isVipUpgradeFlow" class="vip-upgrade-dialog-hint">
                        升级SVIP所需金额：剩余VIP时间*{{ vipUpgradeRemainMoney }}元，权益赠送立即生效
                    </div>
                    <div class="vip-buy-row" v-if="!isVipUpgradeFlow">
                        <span class="vip-buy-label"><span style="color:#f56c6c;">*</span>选择套餐：</span>
                        <div class="vip-buy-options">
                            <div
                              v-for="(p, idx) in (buyVip.companyVipInterestsPriceVos || [])"
                              :key="p.priceId || idx"
                              :class="buyPriceIndex === idx ? 'pay-option-box pay-option-box-active' : 'pay-option-box'"
                              @click="buyPriceIndex = idx"
                            >
                              {{ p.buyMonth }}个月
                            </div>
                        </div>
                    </div>
                    <div class="vip-buy-row">
                        <span class="vip-buy-label">是否使用侦迹币：</span>
                        <div class="vip-buy-options" style="display:flex;align-items:center;">
                            <el-switch
                              v-model="useCoin"
                              :disabled="traceCoinFrozen || Number(coinBalance || 0) <= 0"
                              @change="handleUseCoinChange"
                            />
                            <span style="font-size: 12px; color: #999; margin-left: 8px">
                              （余额{{ coinBalance }}）
                            </span>
                            <span
                              v-if="traceCoinFrozen"
                              style="font-size: 12px; color: #FE574A; margin-left: 8px"
                            >
                              （侦迹币已被冻结）
                            </span>
                            <span
                              v-if="Number(buyCoinDeduct) > 0"
                              style="font-size: 12px; color: #FE574A; margin-left: 8px"
                            >
                              减{{ buyCoinDeduct }}元
                            </span>
                        </div>
                    </div>
                    <div class="vip-buy-row" v-if="vipNeedThirdPay">
                        <span class="vip-buy-label"><span style="color:#f56c6c;">*</span>支付方式：</span>
                        <div class="vip-buy-options">
                            <div
                              v-for="m in buyPayMethodList"
                              :key="m.id"
                              :class="buyPayMethod === m.id ? 'pay-option-box pay-option-box-active' : 'pay-option-box'"
                              @click="buyPayMethod = m.id"
                            >
                              {{ m.name }}
                            </div>
                            <div v-if="useCoin" style="font-size: 12px; color: #999; margin-top: 4px; width: 100%;">
                              侦迹币不足，剩余需支付{{ buyFinalPrice }}元
                            </div>
                        </div>
                    </div>
                    <div class="vip-buy-row">
                        <span class="vip-buy-label">价格：</span>
                        <div class="vip-buy-value">
                            <span style="font-size: 16px;color:#FE574A;">{{ buyFinalPrice }}</span> 元
                            <span
                              v-if="buyOriginalPrice != null && buyDiscountPrice != null"
                              style="font-size: 12px; color: #999; margin-left: 8px"
                            >
                              （原价{{ buyOriginalPrice }}元）
                            </span>
                        </div>
                    </div>
                    <div class="vip-buy-row" v-if="!isVipUpgradeFlow">
                        <span class="vip-buy-label">数量：</span>
                        <div class="vip-buy-value">
                            <el-input-number
                              size="small"
                              v-model="buyNum"
                              :min="1"
                            />
                        </div>
                    </div>
                    <div class="vip-buy-row">
                        <span class="vip-buy-label">到期时间：</span>
                        <div class="vip-buy-value">
                            <span v-if="buyExpireLoading">计算中...</span>
                            <span v-else>{{ buyExpireText || '购买后按规则生效' }}</span>
                        </div>
                    </div>
                    <div style="text-align: center; margin-bottom: 10px; font-size: 12px;">
                      付费即表示同意 <span style="color: #409eff ; cursor: pointer;" @click="handelAgreement">《侦迹云增值服务协议》</span>
                    </div>
                </div>
                <template slot="footer">
                  <div class="dialog-model-footer-btns">
                    <el-button
                      class="dialog-model-btn dialog-model-btn-cancel"
                      @click="buyDialogVisible = false"
                      >取 消</el-button
                    >
                    <el-button
                      class="dialog-model-btn dialog-model-btn-confirm"
                      :loading="buyLoading"
                      @click="handleSubmitBuy"
                      >确 认</el-button
                    >
                  </div>
                </template>
            </dialogModel>
            
        </div>
        <CommonPayment
              :VisiblePayment="VisiblePayment"
              :alipayForm="alipayForm"
              :totalAmount="totalAmount"
              :payMethod="payMethod"
              :orderId="orderId"
              :businessType="businessType"
              :queryType="'proxy'"
              @handlePayment="handlePaymentClose"
              @handleSuccess="handlePaySuccess"
            />
            <VerificationPwd
              :VisiblePwd="VisiblePwd"
              @handleClosePwd="VisiblePwd = false"
              @handleUnderstandPwd="handleUnderstandPwd"
            />
    </div>
</template>

<script>
import {
    vipInterests,
    vipPay,
    calculateEndTime,
    getVipLevel,
    calculateUpgradePrice,
} from "@/assets/api/firm/firmProp.js";
import { selectCompanyWalletList } from "@/assets/api/firm/firmCenter.js";
import { queryCompanyPaySetting } from "@/assets/api/Agency/Enterprise";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../../firmCenter/ProxyService/Enterprise/Bookkeeping/components/IndexCom/VerificationPwd.vue";
import { PAYMENT_OPTIONS, DEFAULT_PAYMENT_METHOD, PAYMENT_METHODS } from "@/utils/paymentMethods";

export default {
    components: {
      CommonPayment,
      VerificationPwd,
    },
    data() {
        return {
            /**
             * 页面标题（取路由名）
             * 仅用于顶部 breadcrumb 展示
             */
            routeName: "",
            // 接口返回的 VIP 列表（普通 VIP、SVIP 等）
            vipList: [],
            /**
             * 企业当前 VIP 等级
             * 约定：0/其他 = 普通；1 = VIP；2 = SVIP（与 FirmLogo.vue 保持一致）
             */
            companyVipLevel: 0,
            // 升级SVIP所需金额（未返回时为空）
            vipUpgradeRemainMoney: null,
            // 购买弹窗
            buyDialogVisible: false,
            /**
             * 当前正在购买的 VIP 套餐对象（来自 vipList）
             * 用于计算 priceId / vipId 以及展示权益信息
             */
            buyVip: null,
            /**
             * 选中的价格档位索引（buyVip.companyVipInterestsPriceVos 的下标）
             */
            buyPriceIndex: 0,
            /**
             * 购买数量（buyCount）
             */
            buyNum: 1,
            buyLoading: false,
            // 侦迹币抵扣
            /**
             * 是否使用侦迹币抵扣（UI 开关）
             * 规则：每次打开弹框默认 false；余额为 0 时开关禁用
             */
            useCoin: false,
            /**
             * 企业侦迹币余额（来自企业钱包接口）
             */
            coinBalance: 0,
            /**
             * 企业侦迹币账号状态（accountStatus：0冻结 1开启）
             */
            traceCoinAccountStatus: "",
            /**
             * 冻结原因（冻结状态展示）
             */
            traceCoinFreezeReason: "",
            // 到期时间（接口计算）
            /**
             * 购买后到期时间（由 calculateEndTime 接口计算后回填）
             * 接口返回示例：{ code:0, data:"2027-08-26" }
             */
            buyExpireText: "",
            // calculateEndTime 接口返回的价格信息（用于展示“原价/折扣价”）
            buyOriginalPrice: null,
            buyDiscountPrice: null,
            /**
             * 到期时间计算 loading（用于“计算中...”展示）
             */
            buyExpireLoading: false,
            // 支付方式：支付宝 / 微信（侦迹币不再作为支付方式）
            /**
             * 第三方支付方式（当抵扣后仍需支付时必选）
             * 取值：ALIPAY / WECHAT_PAY
             */
            buyPayMethod: DEFAULT_PAYMENT_METHOD,
            buyPayMethodList: PAYMENT_OPTIONS,
            // 支付弹框（支付宝/微信二维码）+ 支付密码
            VisiblePayment: false,
            VisiblePwd: false,
            alipayForm: "",
            totalAmount: "",
            orderId: "",
            businessType: "",
            payMethod: "",
            /** 是否开通企业支付密码（与充值/广告等页一致，取自 queryCompanyPaySetting） */
            PaymentPassword: false,
        };
    },
    created() {
        this.routeName = this.$route.name;
    },
    mounted() {
        this.loadVipList();
        this.loadVipLevel();
        this.refreshCompanyPaySetting();
    },
    computed: {
        /**
         * 是否冻结中（冻结时不允许侦迹币抵扣/支付）
         */
        traceCoinFrozen() {
            return String(this.traceCoinAccountStatus) === "0";
        },
        /**
         * 当前选中的价格档（对象）
         * 字段常见：priceId / id、price、buyMonth ...
         */
        buyPriceSpec() {
            if (!this.buyVip) return null;
            const arr = this.buyVip.companyVipInterestsPriceVos || [];
            return arr[this.buyPriceIndex] || arr[0] || null;
        },
        /**
         * 单价（数值化后用于计算总价）
         */
        buyUnitPrice() {
            const spec = this.buyPriceSpec;
            const p = spec && spec.price != null ? Number(spec.price) : 0;
            return isNaN(p) ? 0 : p;
        },
        /**
         * 原始总价（未抵扣）
         */
        buyTotalPrice() {
            const n = Number(this.buyNum) || 0;
            return this.$tool.num.mul(this.buyUnitPrice, n);
        },
        /**
         * 侦迹币可抵扣金额（按“总价 vs 余额”取最小）
         */
        buyCoinDeduct() {
            const num = this.$tool.num;
            const original = num.toNumber(this.buyPayBasePrice);
            const balance = num.toNumber(this.coinBalance);
            if (!this.useCoin || this.traceCoinFrozen || balance <= 0) return 0;
            return num.min(original, balance);
        },
        /**
         * 抵扣后应付金额（用于决定是否需要选择支付宝/微信）
         */
        buyFinalPrice() {
            const num = this.$tool.num;
            const original = num.toNumber(this.buyPayBasePrice);
            const deduct = num.toNumber(this.buyCoinDeduct);
            return num.max(0, num.sub(original, deduct));
        },
        /**
         * 支付基准金额（优先折扣价）
         * calculateEndTime 的 originalPrice/discountPrice 是“订单维度总额”，已包含 buyCount
         */
        buyPayBasePrice() {
            return Number(this.buyDiscountPrice) || 0;
        },
        /**
         * 是否仍需第三方支付（抵扣后金额 > 0）
         */
        vipNeedThirdPay() {
            return Number(this.buyFinalPrice || 0) > 0;
        },
        /**
         * 是否处于“VIP -> SVIP 升级”弹窗场景：
         * - 当前企业等级为 VIP（1）
         * - 当前打开的目标套餐为 SVIP（id=3）
         */
        isVipUpgradeFlow() {
            const currentLevel = Number(this.companyVipLevel || 0);
            const targetVipId = Number(
                this.buyVip && this.buyVip.id != null ? this.buyVip.id : 0
            );
            return currentLevel === 1 && targetVipId === 3;
        },
    },
    watch: {
        /**
         * 关闭弹框时清理展示状态
         */
        buyDialogVisible(val) {
            if (!val) {
                this.buyExpireText = "";
                this.buyExpireLoading = false;
            }
        },
        /**
         * 切换套餐时重新计算到期时间
         */
        buyPriceIndex() {
            if (this.buyDialogVisible) this.refreshBuyExpireText();
        },
        /**
         * 修改数量时重新计算到期时间
         */
        buyNum() {
            if (this.buyDialogVisible) this.refreshBuyExpireText();
        },
    },
    methods: {
        // 点击协议查看协议详情
        handelAgreement() {
            const route = this.$router.resolve({
                path: "/AboutUs/Express",
                query: { name: "侦迹云增值服务协议" },
            });
            window.open(route.href, '_blank');
        },
        /**
         * 根据当前 vipLevel 生成按钮文案
         * - 普通vip：VIP/SVIP 两个都“立即购买”
         * - VIP：VIP“立即续费”，SVIP“立即升级”
         */
        getVipActionText(vip) {
            const currentLevel = Number(this.companyVipLevel || 0);
            const targetVipId = Number(vip && vip.id != null ? vip.id : 0);

            // 普通：两个都立即购买
            if (currentLevel === 0) return "立即购买";

            // VIP：VIP续费，SVIP升级
            if (currentLevel === 1) {
                if (targetVipId === 2) return "立即续费";
                if (targetVipId === 3) return "立即升级";
                return "立即购买";
            }

            // SVIP（默认兜底）：VIP购买、SVIP续费
            if (currentLevel === 2) {
                if (targetVipId === 3) return "立即续费";
                return "立即购买";
            }

            return "立即购买";
        },

        // 获取企业当前 vip 等级（普通 VIP/VIP/SVIP）
        loadVipLevel() {
            return getVipLevel({}, 1, 10)
                .then((res) => {
                    // 兼容：后端返回结构可能不同，尽量稳健解析
                    const d = res && res.data ? res.data : res;
                    const level =
                        d?.vipLevel ??
                        d?.level ??
                        d?.data?.vipLevel ??
                        d?.data?.level ??
                        d ??
                        0;

                    const parsed = Number(level);
                    this.companyVipLevel = isNaN(parsed) ? 0 : parsed;
                })
                .catch(() => {
                    this.companyVipLevel = 0;
                });
        },

        /** 查询企业是否开通支付密码，并同步到 localStorage（与其它购买页一致） */
        refreshCompanyPaySetting() {
            return queryCompanyPaySetting().then((res) => {
                if (res && res.code === 0) {
                    this.PaymentPassword = res.data;
                    try {
                        localStorage.setItem("PaymentPwd", res.data);
                    } catch (e) {}
                }
                return res;
            });
        },
        /**
         * 将接口返回的 YYYY-MM-DD 转成中文展示
         * 不符合格式则原样返回，避免误伤后端返回的完整时间串
         */
        formatExpireDateText(val) {
            if (!val) return "";
            const s = String(val);
            const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:\s|$)/);
            if (!m) return s;
            return `${m[1]}年${m[2]}月${m[3]}日`;
        },
        /**
         * 价格/到期时间计算：
         * - 升级场景（VIP->SVIP）：calculateUpgradePrice，入参 data.vipId
         * - 其他场景：calculateEndTime，入参 vipId/priceId/buyCount
         */
        refreshBuyExpireText() {
            if (!this.buyVip) {
                this.buyExpireText = "";
                return;
            }

            this.buyExpireLoading = true;
            const request = this.isVipUpgradeFlow
                ? calculateUpgradePrice({
                    data: {
                        vipId: this.buyVip.id,
                    },
                })
                : (() => {
                    const spec = this.buyPriceSpec;
                    const buyCount = Number(this.buyNum) || 0;
                    const priceId = spec ? (spec.priceId || spec.id) : null;
                    if (!priceId || buyCount <= 0) {
                        return Promise.resolve({ code: -1, data: null });
                    }
                    return calculateEndTime({
                        data: {
                            vipId: this.buyVip.id,
                            priceId,
                            buyCount,
                        },
                    });
                })();

            return request
                .then((res) => {
                    if (res && res.code === 0 && res.data != null) {
                        const payload = res.data;
                        const endTime = payload.endTime;
                        this.buyOriginalPrice = payload.originalPrice;
                        this.buyDiscountPrice = payload.discountPrice;
                        // 升级提示中的 X 金额，对应接口返回的 vipBasePrice
                        if (this.isVipUpgradeFlow) {
                            this.vipUpgradeRemainMoney = payload.vipBasePrice;
                        }
                        this.buyExpireText = this.formatExpireDateText(endTime);
                    } else {
                        this.buyExpireText = "";
                        this.buyOriginalPrice = null;
                        this.buyDiscountPrice = null;
                        if (this.isVipUpgradeFlow) this.vipUpgradeRemainMoney = null;
                    }
                })
                .catch(() => {
                    this.buyExpireText = "";
                    this.buyOriginalPrice = null;
                    this.buyDiscountPrice = null;
                    if (this.isVipUpgradeFlow) this.vipUpgradeRemainMoney = null;
                })
                .finally(() => {
                    this.buyExpireLoading = false;
                });
        },
        /**
         * 查询企业侦迹币余额（钱包接口）
         * 仅用于前端展示与抵扣判断，支付时仍以 useTraceCoin=1/0 告知后端
         */
        loadTraceCoinBalance() {
            return selectCompanyWalletList(
                {
                    data: {
                        companyId: this.$store.getters.getCompany.id,
                    },
                },
                1,
                10
            ).then((res) => {
                if (res && res.code === 0 && res.data) {
                    if (res.data.traceCoin != null) this.coinBalance = res.data.traceCoin;
                    this.traceCoinAccountStatus = res.data.accountStatus ?? "";
                    this.traceCoinFreezeReason = res.data.reason ?? "";
                    if (String(this.traceCoinAccountStatus) === "0") {
                        this.useCoin = false;
                    }
                }
                return res;
            });
        },
        /**
         * 侦迹币开关变化处理：
         * - 打开：先刷新余额，余额为 0 则强制关闭
         * - 关闭：不额外动作
         */
        handleUseCoinChange(val) {
            if (val) {
                return this.loadTraceCoinBalance().then(() => {
                    if (this.traceCoinFrozen) {
                        this.useCoin = false;
                        this.$tool.PromptBox(
                            "error",
                            `侦迹币已冻结，无法使用：${this.traceCoinFreezeReason || "未知原因"}`
                        );
                        return;
                    }
                    if (Number(this.coinBalance || 0) <= 0) {
                        this.useCoin = false;
                    }
                });
            }
            return Promise.resolve();
        },
        /**
         * 拉取 VIP 权益列表（页面主数据）
         */
        loadVipList() {
            return vipInterests({}, 1, 10).then((res) => {
                if (res && res.code === 0 && Array.isArray(res.data)) {
                    this.vipList = res.data;
                } else {
                    this.vipList = [];
                }
                return res;
            });
        },
        /**
         * 打开购买弹窗：
         * - 初始化默认值（侦迹币默认关闭）
         * - 拉取余额
         * - 调到期时间计算接口
         */
        openBuyDialog(vip) {
            if (!this.$checkAction()) return;
            this.buyVip = vip || null;
            this.buyPriceIndex = 0;
            this.buyNum = 1;
            this.buyPayMethod = "ALIPAY";
            // 每次打开付款弹框，默认关闭“使用侦迹币”
            this.useCoin = false;
            // 打开时先清空冻结/余额状态，避免上一笔数据导致开关短暂可用
            this.coinBalance = 0;
            this.traceCoinAccountStatus = "";
            this.traceCoinFreezeReason = "";
            this.buyExpireText = "";
            this.buyOriginalPrice = null;
            this.buyDiscountPrice = null;
            this.buyExpireLoading = false;
            this.buyDialogVisible = true;
            // 打开后再异步刷新余额与到期时间（不阻塞弹框展示）
            this.loadTraceCoinBalance();
            this.refreshBuyExpireText();
            this.refreshCompanyPaySetting();
        },
        async handleSubmitBuy() {
            if (this.vipNeedThirdPay && this.buyPayMethod !== "ALIPAY" && this.buyPayMethod !== "WECHAT_PAY") {
                this.$message.warning("请选择支付方式");
                return;
            }
            // 确保 calculateEndTime 已返回 originalPrice/discountPrice（避免切套餐/数量后用到旧值）
            if (this.buyExpireLoading || this.buyDiscountPrice == null || this.buyOriginalPrice == null) {
                await this.refreshBuyExpireText();
            }
            await this.refreshCompanyPaySetting();
            if (this.PaymentPassword === false) {
                this.handleVipPay();
            } else {
                this.VisiblePwd = true;
            }
        },
        // 支付密码确认后调 vipPay（无密码时 pwd 为空不传 password）
        handleVipPay(pwd) {
            if (!this.buyVip) return;
            const spec = this.buyPriceSpec;
            if (!spec) return;
            if (!this.buyNum || this.buyNum <= 0) {
                this.$message.warning("请输入购买数量");
                return;
            }
            /**
             * useTraceCoin：是否使用侦迹币抵扣（由后端决定实际抵扣逻辑）
             * effectivePayMethod：
             * - 抵扣后仍需支付：ALIPAY / WECHAT_PAY
             * - 抵扣后应付为 0 且勾选侦迹币：TRACE_COIN_PAY_VIP（侦迹币直付，不弹二维码）
             */
            const useTraceCoin =
                this.useCoin && !this.traceCoinFrozen && Number(this.coinBalance || 0) > 0;
            const needThirdPay = this.vipNeedThirdPay;
            const effectivePayMethod = needThirdPay
                ? this.buyPayMethod
                : useTraceCoin
                    ? PAYMENT_METHODS.TRACE_COIN
                    : this.buyPayMethod;
            const data = {
                data: {
                    identityType: "COMPANY",
                    businessType: "VIP_BUY",
                    businessInfo: {
                        vipId: this.buyVip.id,
                        priceId: spec.priceId || spec.id,
                        buyCount: this.buyNum,
                        useTraceCoin: useTraceCoin ? 1 : 0,
                    },
                    payMethod: effectivePayMethod,
                },
            };
            if (pwd) data.data.password = pwd;
            this.buyLoading = true;
            vipPay(data, 1, 10)
                .then((res) => {
                    if (res && (res.code === 0 || res.code === 200 || res.success)) {
                        const resPayMethod =
                            (res && res.data && res.data.payMethod) || data.data.payMethod || "";
                        const isTraceCoinPay = String(resPayMethod).indexOf("TRACE_COIN_PAY") === 0;
                        // 侦迹币支付：不弹二维码，直接成功并刷新
                        if (isTraceCoinPay) {
                            this.buyDialogVisible = false;
                            this.loadVipList();
                            this.loadVipLevel();
                            this.$tool.PromptBox("success", "付款成功");
                        } else {
                            // 支付宝/微信：弹二维码
                            this.alipayForm = res.data && res.data.payPage ? res.data.payPage : "";
                            // 支付弹窗显示的交易金额：以 calculateEndTime 返回的折扣价/侦迹币抵扣后的应付为准
                            this.totalAmount =
                                this.buyFinalPrice != null && !isNaN(Number(this.buyFinalPrice))
                                    ? this.buyFinalPrice
                                    : res.data && res.data.totalAmount
                                        ? res.data.totalAmount
                                        : "";
                            this.orderId = res.data && res.data.orderId ? res.data.orderId : "";
                            this.businessType = (res.data && res.data.businessType) || data.data.businessType;
                            this.payMethod = (res.data && res.data.payMethod) || data.data.payMethod;
                            this.VisiblePayment = true;
                        }
                    } else {
                    }
                    return res;
                })
                .catch((e) => {
                    this.$message.error(e?.message || "支付失败");
                })
                .finally(() => {
                    this.buyLoading = false;
                    this.VisiblePwd = false;
                });
        },
        // 支付密码弹框回调
        handleUnderstandPwd(pwd) {
            this.handleVipPay(pwd);
        },
        handlePaymentClose() {
            this.VisiblePayment = false;
        },
        handlePaySuccess() {
            this.VisiblePayment = false;
            this.buyDialogVisible = false;
            this.loadVipList();
            this.loadVipLevel();
        },
        // 到期时间展示文案
        formatExpire(expiredType, expiredNum) {
            if (expiredNum == null) return "";
            if (expiredType === 1) return `有效期${expiredNum}个月`;
            if (expiredType === 2) return `有效期${expiredNum}年`;
            if (expiredType === 3) return `有效期${expiredNum}天`;
            return `有效期${expiredNum}天`;
        },
        /** 卡片背景图（设计稿 bj_*.svg） */
        vipCardBgSrc(id) {
            const n = Number(id);
            if (n === 1) return "https://tracecloud-1319979439.cos.ap-nanjing.myqcloud.com/rootSysDir/sysimg/bj_normal_VIP.svg";
            if (n === 2) return "https://tracecloud-1319979439.cos.ap-nanjing.myqcloud.com/rootSysDir/sysimg/bj_VIP.svg";
            return "https://tracecloud-1319979439.cos.ap-nanjing.myqcloud.com/rootSysDir/sysimg/bj_SVIP.svg";
        },
        vipCardTheme(id) {
            const n = Number(id);
            if (n === 1) return "plain";
            if (n === 2) return "vip";
            return "svip";
        },
    },

};
</script>
<style lang='less' scoped>
.box-vip {
    width: 1200px;
    box-sizing: border-box;
    min-height: 740px;
    margin-top: 20px;
    padding: 32px 24px 40px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 24px;
}

.vip-card-wrap {
    position: relative;
    width: 360px;
    height: 655px;
    flex-shrink: 0;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.vip-card-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
    user-select: none;
}

/* 左上角标题区：宽约 174px，避免与右侧 3D 图标重叠 */
.vip-card-header-text {
    position: absolute;
    z-index: 2;
    left: 24px;
    top: 30px;
    max-width: 174px;
    pointer-events: none;
}

.vip-card-header-main {
    font-size: 28px;
    font-weight: 700;
    color: #fff;
    line-height: 1.15;
    letter-spacing: 0.02em;
    text-shadow: 0 1px 8px rgba(0, 0, 0, 0.15);
}

.vip-card-header-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.vip-card-header-sub {
    margin: 10px 0 0;
    padding: 0;
    font-size: 12px;
    line-height: 1.45;
    color: rgba(255, 255, 255, 0.95);
    font-weight: 500;
}

.vip-card-header-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    font-size: 10px;
    font-weight: 700;
    border-radius: 6px;
    letter-spacing: 0.02em;
}

.vip-card-header-badge--vip {
    color: rgba(255, 255, 255, 0.98);
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.4);
}

.vip-card-header-badge--svip {
    color: #6b4200;
    background: linear-gradient(180deg, #fff0c2, #e8b84a);
    border: 1px solid rgba(255, 220, 140, 0.9);
}

/* 设计稿：标题区左侧文案约 174px 至 3D 图标起点，正文与卡片左右留白对齐 */
.vip-card-content {
    position: relative;
    z-index: 1;
    height: 100%;
    box-sizing: border-box;
    padding: 218px 20px 28px 24px;
    display: flex;
    flex-direction: column;
}

/* SVIP：白底胶囊 + 红心 + 文案（与稿一致，非红底条） */
.vip-svip-tag {
    align-self: flex-start;
    margin-bottom: 12px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px 6px 10px;
    font-size: 12px;
    line-height: 1.3;
    font-weight: 600;
    color: #333;
    background: #ffffff;
    border-radius: 999px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.vip-svip-tag-heart {
    color: #ff3b30;
    font-size: 13px;
    line-height: 1;
}

.vip-benefits-title {
    font-size: 18px;
    font-weight: 700;
    color: #333;
    margin-bottom: 12px;
    margin-left: 18px;
}

.vip-benefits-list {
    margin: 0;
    padding-left: 18px;
    font-size: 14px;
    line-height: 1.65;
    color: #444;
    flex: 0 0 auto;
}

.vip-plain-empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 0 8px 40px;
}

.vip-plain-empty-title {
    margin: 0 0 12px;
    font-size: 22px;
    font-weight: 700;
    color: #1a6fd4;
}

.vip-plain-empty-desc {
    margin: 0;
    font-size: 14px;
    line-height: 1.6;
    color: #003466 ;
    font-weight: 600;
}

/* 套餐价格区：浅蓝圆角底 + 深蓝紫字（与设计稿一致） */
.vip-price-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px 20px;
    margin-top: auto;
    padding: 16px 18px 18px;
    background: #e8f2ff;
    border-radius: 14px;
    box-sizing: border-box;
}

.vip-price-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 14px;
    color: #2a3558;
}

.vip-price-month {
    margin-bottom: 6px;
    color: #2a3558;
    font-weight: 500;
}

.vip-price-num {
    font-size: 17px;
    font-weight: 700;
    color: #252d5c;
    letter-spacing: 0.02em;
}

.vip-card-footer {
    margin-top: 18px;
    padding-top: 4px;
}

.vip-action-btn {
    display: block;
    width: 100%;
    height: 44px;
    border: none;
    border-radius: 22px;
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    transition: opacity 0.2s;
}

.vip-action-btn:hover {
    opacity: 0.92;
}

.vip-card-wrap--plain .vip-action-btn {
    display: none;
}

.vip-card-wrap--vip .vip-action-btn {
    background: linear-gradient(90deg, #7b5fd4, #9b7ae8);
    box-shadow: 0 4px 12px rgba(123, 95, 212, 0.45);
}

.vip-card-wrap--svip .vip-action-btn {
    background: linear-gradient(90deg, #e89a2a, #f5b041);
    box-shadow: 0 4px 12px rgba(232, 154, 42, 0.45);
}

.vip-buy-dialog {
    padding: 24px 40px 0px;
}

.vip-buy-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    font-size: 14px;
    color: #333;
    min-height: 35px;
}

.vip-buy-label {
    width: 150px;
    text-align: right;
    margin-right: 12px;
    color: #606266;
    line-height: 35px;
    flex-shrink: 0;
}

.vip-buy-options {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    line-height: 35px;
}

.pay-option-box {
  width: 90px;
  height: 35px;
  line-height: 35px;
  background: #ffffff;
  border: 1px solid #409eff ;
  border-radius: 5px;
  font-size: 12px;
  text-align: center;
  color: #409eff ;
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.pay-option-box-active {
  background: rgba(97, 144, 232, 0.27);
}

.vip-buy-value {
    flex: 1;
    line-height: 35px;
}

.vip-upgrade-dialog-hint {
    margin-bottom: 14px;
    font-size: 12px;
    color: #333;
    line-height: 18px;
    text-align: center;
}
</style>
